import React, { Component, Fragment } from "react"
import { Formik, Form, Field } from "formik"
import { withRouter } from "../../helpers/withRouter"
import {
  Row,
  ButtonGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Card,
  CardBody,
  Col,
  Input,
} from "reactstrap"
import ListPageHeader from "../../components/custom/ListPageHeader"
import ListPage from "../../components/custom/ListPage"
import { merchantValidation } from "../../helpers/validations"
import { Message } from "../../helpers/language_helper"
import { SuccessMessage, ErrorMessage } from "../../helpers/notifications"
import { QueryRequest, MutateRequest } from "../../helpers/service_helper"
import {
  getAllMerchantsQuery,
  createMerchantMutation,
  updateMerchantMutation,
  deleteMerchantMutation,
  fileUploadQuery,
} from "./Queries"
import axios from "axios"
import { Helmet } from "react-helmet-async"
import FileDisplay from "components/custom/FileDisplay"
import { StatusCodes } from "constants/defaultValues"

class Merchant extends Component {
  constructor(props) {
    super(props)
    this.state = {
      manageModal: false,
      Label: "",
      currentpage: 1,
      buttonAction: false,
      isLoading: true,
      pageSizeOptions: [25, 50, 100, 500],
      pageLimit: 25,
      totalCount: 0,
      keyField: "id",
      viewModal: false,
      merchantList: [],

      listRequestModel: {
        searchString: "",
        sortCondition: null,
        pageNumber: 1,
        pageLimit: 25,
      },
      merchant: {
        taskName: "",
        ageGroupId: "",
        icon: "",
      },
      columns: [
        {
          name: "Name",
          selector: row => row.merchantName,
          sortable: true,
          cell: row => <span>{row.merchantName ? row.merchantName : ""}</span>,
        },
        {
          name: "Description",
          selector: row => row.description,
          sortable: true,
          cell: row => <span>{row.description ? row.description : ""}</span>,
        },
        {
          name: "Address",
          selector: row => row.address,
          sortable: true,
          cell: row => <span>{row.address ? row.address : ""}</span>,
        },
        {
          name: "Mobile Number",
          selector: row => row.mobileNumber,
          sortable: true,
          cell: row => <span>{row.mobileNumber ? row.mobileNumber : ""}</span>,
        },

        {
          name: "Logo",
          selector: row => row.logoURL,
          sortable: true,
          cell: row => (
            <span>
              {" "}
              {row.logoURL ? <FileDisplay Value={row.logoURL} /> : ""}
            </span>
          ),
        },
        {
          name: "Action",
          selector: row => row.action,
          sortable: false,
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                {/* <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {row.}
                </Button> */}
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {Message("edit")}
                </Button>

                <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {Message("delete")}
                </Button>
              </ButtonGroup>
            </Row>
          ),
        },
      ],
    }
  }

  componentDidMount() {
    this.getAllMerchant()
  }
  getAllMerchant = async value => {
    this.setState({
      isLoading: true,
    })
    const { listRequestModel } = this.state
    var values = listRequestModel
    const response = await QueryRequest(getAllMerchantsQuery, values)
    var merchantsValue = response?.data?.getAllMerchant?.items
    if (merchantsValue) {
      this.setState({
        isLoading: false,
        merchantList: merchantsValue,
        totalPage:
          response?.data?.getAllMerchants?.pagination?.totalCount /
          response?.data?.getAllMerchants?.pagination?.pageLimit,
        totalCount: response?.data?.getAllMerchants?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }

  /** handle list page  start  */
  handleSort = (column, sortDirection) => {
    var sortObj = {}
    sortObj[column.selector] = sortDirection === "asc" ? "asc" : "desc"
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          sortCondition: sortObj,
        },
      },
      function () {
        this.getAllMerchant()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getAllMerchant()
      }
    )
  }

  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getAllMerchant()
      }
    )
  }

  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getAllMerchant()
        }
      }
    )
  }

  handleEdit = row => {
    if (row) {
      this.setState({
        merchant: row,
        manageModal: !this.state.manageModal,
        IsEdited: true,
        Label: "Edit",
      })
    }
  }

  /** Submit Function Start */
  handleSubmit = async values => {
    if (typeof values.logoURL === "object" && values.logoURL) {
      let fileupload = {
        type: "photo",
        fileName: values.logoURL?.name,
      }
      const fileUploadresponse = await QueryRequest(fileUploadQuery, fileupload)
      let data = fileUploadresponse?.data?.getUploadUrl

      if (data.status === "Success") {
        axios
          .post(data.url, values.logoURL, {
            headers: { "Content-Type": values.logoURL?.type },
          })
          .then(async res => {
            console.log(res)
            if (res.status.toString() === StatusCodes.Success) {
              if (this.state.Label == "Add") {
                data = {
                  merchantName: values.merchantName,
                  description: values.description,
                  mobileNumber: values.mobileNumber.toString(),
                  address: values.address,
                  logoURL: data.url.split("?")[0],
                }
                await MutateRequest(createMerchantMutation, { data: data })
                  .then(res => SuccessMessage(Message("merchant.add")))
                  .catch(e => ErrorMessage(e))
                this.setState({
                  manageModal: !this.state.manageModal,
                })
                this.getAllMerchant()
              } else {
                const Data = {
                  id: this.state.merchant.id,
                  data: {
                    merchantName: values.merchantName,
                    description: values.description,
                    mobileNumber: values.mobileNumber.toString(),
                    address: values.address,
                    logoURL: data.url.split("?")[0],
                  },
                }
                console.log(data)
                await MutateRequest(updateMerchantMutation, Data)
                  .then(res => SuccessMessage(Message("merchant.update")))
                  .catch(e => ErrorMessage(e))
                this.setState({
                  manageModal: !this.state.manageModal,
                })
                this.getAllMerchant()
              }
            } else {
              ErrorMessage(Message("fieldUpload.error"))
            }
          })
          .catch(err => ErrorMessage(Message(err)))
      } else {
        ErrorMessage(Message("fieldUpload.error"))
      }
    } else {
      this.state.Label == "Add"
        ? this.addMerchant(values)
        : this.editMerchant(values)
    }
  }

  addMerchant = async values => {
    let data = {
      merchantName: values.merchantName,
      description: values.description,
      mobileNumber: values.mobileNumber?.toString(),
      address: values.address,
      logoURL: values.logoURL,
    }
    // if (values.logoURL) data.logoURL = values.logoURL

    await MutateRequest(createMerchantMutation, { data: data })
      .then(res => SuccessMessage(Message("merchant.add")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllMerchant()
  }

  editMerchant = async values => {
    // alert("ret")
    let Data = {
      id: this.state.merchant.id,
      data: {
        merchantName: values.merchantName,
        description: values.description,
        mobileNumber: values.mobileNumber?.toString(),
        address: values.address,
        logoURL: values.logoURL,
      },
    }
    // if (values.logoURL) data.logoURL = values.logoURL
    await MutateRequest(updateMerchantMutation, Data)
      .then(res => SuccessMessage(Message("merchant.update")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllMerchant()
  }

  addBtnClick = () => {
    this.setState({
      merchant: {},
      manageModal: !this.state.manageModal,
      Label: "Add",
    })
  }

  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      merchant: row,
    })
  }

  toggleManageModal = () => {
    this.setState({
      merchant: {},
      manageModal: !this.state.manageModal,
    })
  }

  deleteMerchant = async id => {
    var values = {
      id: id,
    }
    const response = await MutateRequest(deleteMerchantMutation, values)
    var merchantdeleteValue = response?.data
    if (merchantdeleteValue.deleteOneMerchant.status === "Success") {
      SuccessMessage(Message("merchant.delete"))
      this.getAllMerchant()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  toggleViewModal = url => {
    this.setState({
      viewModal: !this.state.viewModal,
      documentView: url,
      merchantDetail: url ? url : "",
    })
  }

  render() {
    const initialValues = this.state.merchant
    const conditionalRowStyles = [
      {
        when: row => row,
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ]
    return (
      <Fragment>
        <Helmet>
          <title>{Message("title.merchant")}</title>
        </Helmet>
        <div className="page-content">
          <div className="container-fluid">
            <Card>
              <CardBody>
                <ListPageHeader
                  heading={`${"Home"}.${"Merchant"}`}
                  buttonText={Message("add.merchant")}
                  onTextChange={this.searchQueryChanged}
                  buttonClick={this.addBtnClick}
                  searchValue={this.state.listRequestModel.searchString}
                />
                <ListPage
                  conditionalRowStyles={conditionalRowStyles}
                  columns={this.state.columns}
                  data={this.state.merchantList}
                  keyField={this.state.keyField}
                  totalCount={this.state.totalCount}
                  rowClicked={this.HandleRowClicked}
                  onSort={this.handleSort}
                  pageLimit={this.state.pageLimit}
                  pageSizeOptions={this.state.pageSizeOptions}
                  rowsPerPageOnChange={this.handlePerRowsChange}
                  pageChange={this.handlePageChange}
                  isDataLoading={this.state.isLoading}
                  overFlowXRemoval={true}
                />
              </CardBody>
            </Card>
            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.merchant")}
              </ModalHeader>

              <ModalBody>
                <Fragment>
                  <Row className="mb-1 mt-2">
                    <p className="ms-3 me-3 font-size-15">
                      {Message("delete.confirmation")}{" "}
                      <span>
                        <strong>{this.state.merchant?.merchantName}</strong>{" "}
                        {Message("merchant")}{" "}
                      </span>
                      {"?"}
                    </p>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() => this.deleteMerchant(this.state.merchant.id)}
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size="lg"
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label == "Add"
                  ? Message("add.merchant")
                  : Message("update.merchant")}
              </ModalHeader>
              <Formik
                initialValues={initialValues}
                validationSchema={merchantValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row>
                          <Col lg="6" xl="6" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("name")}
                              </Label>

                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="merchantName"
                                type="text"
                              />
                              {errors.merchantName && (
                                <div className="invalid-feedback d-block">
                                  {errors.merchantName}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col lg="6" xl="6" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("user.mobileNumber")}
                              </Label>

                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="mobileNumber"
                                type="text"
                              />
                              {errors.mobileNumber && (
                                <div className="invalid-feedback d-block">
                                  {errors.mobileNumber}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col lg="6" xl="6" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("description")}
                              </Label>

                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="description"
                                type="text"
                                component="textarea"
                              />
                              {errors.description && (
                                <div className="invalid-feedback d-block">
                                  {errors.description}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col lg="6" xl="6" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("address")}
                              </Label>

                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="address"
                                type="text"
                                component="textarea"
                              />
                              {errors.address && (
                                <div className="invalid-feedback d-block">
                                  {errors.address}
                                </div>
                              )}
                            </FormGroup>
                          </Col>

                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label>{Message("logo")}</Label>
                              <br />
                              <Input
                                download
                                style={{ display: "none" }}
                                id="Image"
                                type="file"
                                onChange={e => {
                                  this.setState({
                                    photo: e.target.files[0],
                                  })
                                  setFieldValue("logoURL", e.target.files[0])
                                }}
                              />

                              <label for="Image" class="btn btn-secondary">
                                <i class="far fa-file"></i>
                              </label>
                              {values.logoURL ? (
                                <div>
                                  <Label>{values.logoURL?.name}</Label>
                                </div>
                              ) : (
                                ""
                              )}
                              {this.state.Label == "Edit" ? (
                                values.logoURL &&
                                typeof values.logoURL !== "object" ? (
                                  <FileDisplay Value={values.logoURL} />
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                            </FormGroup>
                          </Col>
                          <Col></Col>
                        </Row>
                      </Fragment>
                    </ModalBody>

                    <ModalFooter>
                      <div className="container-fluid">
                        <Row>
                          <Col sm={6} className="required">
                            &nbsp;{Message("mandatory.fields")}
                          </Col>
                          <Col sm={6}>
                            <div className="text-sm-right d-none d-sm-block">
                              <FormGroup className="float-sm-right ">
                                <Button type="submit" color="primary">
                                  {this.state.Label == "Edit"
                                    ? "Update"
                                    : "Add"}
                                </Button>

                                <Button
                                  color="danger"
                                  className="ms-2"
                                  onClick={() => this.toggleManageModal()}
                                >
                                  {Message("cancel")}
                                </Button>
                              </FormGroup>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(Merchant)
